<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <a-form layout="inline" :labelCol="{ style: { width: '70px' } }">
        <a-row>
          <a-col :md="6" :sm="24">
            <a-form-item label="计划单号">
              <global-select
                :value.sync="queryParams.planCode"
                selectType="selectSearch"
                requestApi="/scp/scpDmSporadic/scpDmCodeList"
                :selectItem="{ value: 'label', label: 'label' }"
                searchParam="inputString" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="物料编码">
              <global-select
                :assembleLabel="false"
                :value.sync="queryParams.itemCode"
                selectType="selectSearch"
                requestApi="/mes/mesDiscreteJobs/assemblyBox"
                :selectItem="{ value: 'selectedValue', label: 'selectedValue' }"
                searchParam="itemCode" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="来源单号">
              <!-- <global-select
                :value.sync="queryParams.sourceCode"
                selectType="selectSearch"
                requestApi="/scp/scpFcSporadic/sourceCodeList"
                :selectItem="{ value: 'realValue', label: 'label' }"
                searchParam="itemCode" /> -->
              <global-select
                :value.sync="queryParams.sourceCode"
                selectType="selectSearch"
                requestApi="/scp/scpFcSporadic/scpFcCodeList"
                :selectItem="{ value: 'label', label: 'label' }"
                searchParam="inputString" />
            </a-form-item>
          </a-col>
          <template v-if="advanced">
            <a-col :md="6" :sm="24">
              <a-form-item label="需求交期">
                <a-range-picker
                  class="rp-width"
                  :placeholder="['需求交期从', '需求交期至']"
                  valueFormat="YYYY-MM-DD"
                  format="YYYY-MM-DD"
                  :value="demandDeliveryDate"
                  @change="handlePanelChange"
                />
              </a-form-item>
            </a-col>
          </template>
          <template v-if="advanced">
            <a-col :md="6" :sm="24">
              <a-form-item label="状态">
                <a-select v-model="queryParams.dmStatus" allowClear>
                  <a-select-option v-for="(item) in statusOptions" :key="item.dictValue">{{ item.dictLabel }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </template>
          <template v-if="advanced">
            <a-col :md="6" :sm="24">
              <a-form-item label="工艺大类">
                <global-select
                  :value.sync="queryParams.productBroadCategoryList"
                  selectType="selectMultipleSearch"
                  requestApi="/system/lookup/data/likeList"
                  :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
                  :setParams="{ lookupType: 'SCP_PRODUCT_BROAD_CATEGORY' }"
                  searchParam="lookupValue"
                  :dropdown-match-select-width="false"
                />
              </a-form-item>
            </a-col>
          </template>
          <template v-if="advanced">
            <a-col :md="6" :sm="24">
              <a-form-item label="创建人">
                <global-select
                  ref="createBySearchRef"
                  selectType="selectAssembleSearchByKey"
                  :value.sync="queryParams.createBy"
                  requestApi="/scp/scpFcSporadic/applicantBox"
                  :selectItem="{ value: 'realValue', label: 'label' }"
                  :showLabel="{ value: 'realValue', label: 'label', selectedValue: 'selectedValue' }"
                  searchParam="name"
                />
              </a-form-item>
            </a-col>
          </template>
          <template v-if="advanced">
            <a-col :md="6" :sm="24">
              <a-form-item label="项目组">
                <a-select :max-tag-count="1" show-search allowClear option-filter-prop="children" v-model="queryParams.projectTeam" >
                  <a-select-option v-for="(item) in projectTeams" :key="item.lookupCode">{{ item.lookupValue }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </template>
          <template v-if="advanced">
            <a-col :md="6" :sm="24">
              <a-form-item label="需求类型">
                <global-select
                  ref="demandTypeRef"
                  selectType="selectSearch"
                  :value.sync="queryParams.demandType"
                  requestApi="/scp/scpDemandPlacementBill/demandTypeCombobox"
                  :selectItem="{ value: 'realValue', label: 'label' }"
                  searchParam="demandType"
                />
              </a-form-item>
            </a-col>
          </template>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button @click="onSearch" type="primary">查询</a-button>
              <a-button @click="resetQuery" class="ml8">重置</a-button>
              <a @click="toggleAdvanced" class="ml8">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-page-operator-wrapper" slot="btn">
      <download-modal :apiFun="apiScpDmSporadicNewExport" ref="download" />
      <a-button :disabled="this.dmStatus!=='1'" @click="distributeMsg(2)" type="primary" v-hasPermi="['scp:scpDmSporadic:operate']">提交</a-button>
      <a-button @click="handleExport" type="primary" v-hasPermi="['scp:scpDmSporadic:export']">导出</a-button>
      <a-upload
        name="file"
        :customRequest="handleImport"
        :showUploadList="false"
        accept=".xlsx,.xls"
      >
        <a-button type="primary" :loading="isUploading">导入</a-button>
      </a-upload>
      <a-button :disabled="this.dmStatus!=='4'" @click="distributeMsg(1)" type="primary">返回创建</a-button>
      <a-button :disabled="this.dmStatus!=='1'" @click="distributeMsg(4)" v-hasPermi="['scp:scpDmSporadic:operate']">作废</a-button>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          :selectedRows.sync="selectedRows"
          :multi-select="true"
          rowKey="id"
          @selectedRowChange="selectedRowChange"
          :scroll="{ fixScreen: true, x: 1300 }"
          :toolBox="{
                density: true, // 传入String时 初始化默认表格密度
                fullScreen: false,  // 是否需要全屏
                configKey: $TableKey.SPORADIC_DEMAND_LIST, // 表格方案配置唯一值
              }"
        >
          <!-- 主要代码在这里 -- 下面这些 -->
          <template slot="bzbz" slot-scope="{ text }">
            <a-tooltip placement="top">
              <template slot="title">
                <span>{{ text }}</span>
              </template>
              <span class="ellipsis">{{ text }}</span>
            </a-tooltip>
          </template>
          <span slot="indexId" slot-scope="{index}">
            {{ index+1 }}
          </span>
          <span slot="planQuantity" slot-scope="{ record, text }">
            <a @click="handleOperation(text,record)" class="ml10">{{ record.planQuantity?record.planQuantity:0 }}</a>
          </span>
          <template slot="demandType" slot-scope="{ record }">
            <div v-if="record.dmStatus==='1'" class="select-part">
              <a-select v-model="record.demandType" @change="(val)=>handleDemandTypeChange(val,record)">
                <a-select-option v-for="(item) in orderType" :key="item.lookupCode" :disabled="demandTypeDisabled(record, item.lookupCode)">{{ item.lookupValue }}</a-select-option>
              </a-select>
            </div>
            <span v-else>{{ record.demandType }}</span>

          </template>
          <!--当月满足率-->
          <template slot="curMonthSatisfyRate" slot-scope="{ record }">
            <span>{{ record.curMonthSatisfyRate * 100 }}%</span>
          </template>
          <!--次月满足率-->
          <template slot="nextMonthSatisfyRate" slot-scope="{ record }">
            <span>{{ record.nextMonthSatisfyRate * 100 }}%</span>
          </template>
          <template slot="isStopFlag" slot-scope="{ record }">
            <span >{{ record.isStopFlag === 'Y' ? '是' : '否' }}</span>
          </template>
          <template slot="updateTime" slot-scope="{ text }">
            <span>{{ text && $moment(text).format('YYYY-MM-DD HH:mm') }}</span>
          </template>
          <template slot="formatDate" slot-scope="{ text }">
            <span>{{ text && $moment(text).format('YYYY/MM/DD') }}</span>
          </template>
          <template slot="expirationDate" slot-scope="{ text }">
            <span>{{ text && $moment(text).format('YYYY/MM/DD') }}</span>
          </template>
          <template slot="createTime" slot-scope="{ text }">
            <span>{{ text && $moment(text).format('YYYY-MM-DD HH:mm') }}</span>
          </template>
          <template slot="time" slot-scope="{ text }">
            <span>{{ text && $moment(text).format('YYYY/MM/DD HH:mm') }}</span>
          </template>
          <!-- <template slot="status" slot-scope="{ record }">
            <a-popconfirm
              ok-text="确定"
              cancel-text="取消"
              @confirm="confirmHandleStatus(record)"
              @cancel="cancelHandleStatus(record)"
            >
              <span slot="title">请确认是否<b>{{ record.status === 'Y' ? '停用' : '启用' }}</b>该单位</span>
              <a-switch :checked="record.status === 'Y'" />
            </a-popconfirm>
          </template> -->
          <!-- 操作 -->
          <span slot="operation" slot-scope="{ record }">
            <a v-if="!isEdit || currentId !== record.id" @click="handleEdit(record)" v-hasPermi="['scp:scpDmSporadic:edit']">编辑</a>
            <a v-if="isEdit && currentId === record.id" @click="handleSave(record)" v-hasPermi="['scp:scpDmQuantity:save']">保存</a>
            <a v-if="isEdit && currentId === record.id" @click="handleCancel(record)" class="ml10">取消</a>
          </span>
        </ls-api-table>
        <create-form
          ref="createModal"
          :id="cfId"
          :planQuantity="planQuantity"
          :demandDeliveryDate="demandDeliveryDate"
          @handle-success="onSearch"
        />
      </div>
    </template>
  </ls-table-layout>
</template>

  <script>
  import { generateLsTableResData } from '@/utils/util.js'
  import { apiScpDmSporadicList, apiScpDmSporadic, apiScpDmSporadicState, apiScpDmSporadicNewExport, apiImportSporadic } from '@/api/scp/sporadic-demand/sporadic-demand'
  import CreateForm from './components/CreateForm'
  import moment from 'moment';
  import DownloadModal from '@/views/components/download-modal/download-modal.vue'
  import { parseResFileOrJson } from "@/utils/request";

  export default {
    // eslint-disable-next-line
    name: 'Sporadic-demand',
    components: {
      DownloadModal,
        CreateForm
    },
    data () {
      this.uploadConfig = { // 导入限制
        accept: '.xls,.xlsx',
        limitNumber: 1
        // limitSize: 100
      }
      return {
        apiScpDmSporadicNewExport,
        projectTeams: [], // 项目组
        dmStatus: '',
        planQuantity: 0,
        orderType: [],
        cfId: '',
        // 表格配置1
        tableProps: {
          requestApi: generateLsTableResData(apiScpDmSporadicList, true),
          pageCurrent: true
        },
        // 控制搜索展开
        advanced: true,
        demandDeliveryDate: undefined,
        // 查询参数
        queryParams: {
          createBy: undefined,
          projectTeam: undefined,
          demandType: undefined,
          planCode: undefined,
          dmStatus: '1',
          demandDeliveryDateFrom: undefined,
          demandDeliveryDateTo: undefined,
          itemCode: undefined,
          sourceCode: undefined,
          applicantList: undefined
        },
        isUploading: false,
        // 表格多选
        selectedRowKeys: [],
        selectedRows: [],
        // 状态快码
        statusOptions: [
          {
            dictLabel: "创建",
            dictValue: "1"
          },
          {
            dictLabel: "待审核",
            dictValue: "2"
          },
          {
            dictLabel: "已审核",
            dictValue: "3"
          },
          {
            dictLabel: "已作废",
            dictValue: "4"
          }
        ],
        baseUomFlagOptions: [
          {
            dictLabel: "是",
            dictValue: "Y"
          },
          {
            dictLabel: "否",
            dictValue: "N"
          }
        ],
        // 表格字段
        columns: [
          { title: '序号', scopedSlots: { customRender: 'indexId' }, dataIndex: 'indexId', stickyFixed: 'left', align: 'center', width: 60 },
          { title: '计划单号', dataIndex: 'planCode', ellipsis: true, width: 140, stickyFixed: 'left', align: 'center' },
          { title: '物料编码', dataIndex: 'itemCode', ellipsis: true, width: 140, stickyFixed: 'left', align: 'center' },
          { title: '物料名称', stickyFixed: 'left', dataIndex: 'itemName', width: 120, ellipsis: true, align: 'center' },
          {
            title: '规格描述',
            stickyFixed: 'left',
            dataIndex: 'specification',
            width: 150,
            align: 'left',
            ellipsis: true
            // scopedSlots: { customRender: 'bzbz' }
          },
          { title: '下单类别', dataIndex: 'orderType', width: 110, align: 'center' },
          { title: '销售类目', dataIndex: 'salesCategory', width: 110, align: 'center' },
          { title: '研发分类', dataIndex: 'developType', width: 110, align: 'center' },
          { title: '口径', dataIndex: 'caliberName', width: 110, align: 'center' },
          { title: '主型号', dataIndex: 'mainModel', ellipsis: true, width: 100, align: 'center' },
          { title: '是否停产', scopedSlots: { customRender: 'isStopFlag' }, dataIndex: 'isStopFlag', width: 100, align: 'center' },
          { title: '需求数量', dataIndex: 'quantityDemand', width: 110, align: 'center' },
          { title: '需求交期', dataIndex: 'demandDeliveryDate', scopedSlots: { customRender: 'formatDate' }, width: 120, ellipsis: true, align: 'center' },
          { title: '当月回货需求', dataIndex: 'curMonthReturnDemand', width: 110, align: 'center' },
          { title: '当月回货需求日期', dataIndex: 'curMonthReturnDemandDate', scopedSlots: { customRender: 'formatDate' }, width: 120, align: 'center' },
          { title: '次月回货需求', dataIndex: 'nextMonthReturnDemand', width: 110, align: 'center' },
          { title: '次月回货需求日期', dataIndex: 'nextMonthReturnDemandDate', scopedSlots: { customRender: 'formatDate' }, width: 140, align: 'center' },
          { title: '供应余量', dataIndex: 'supplyRemainQty', width: 110, align: 'center' },
          {
            title: '是否在锁定期内',
            dataIndex: 'inLockFlag',
            width: 100,
            align: 'center',
            customRender: (text, record) => ({ 0: '否', 1: '是' }[record.inLockFlag])
          },
          { title: '需求类型', dataIndex: 'demandDeliveryTypeName', width: 100, align: 'center' },
          { title: 'M+3月预测数量', dataIndex: 'forecastQtyM3', width: 100, align: 'center' },
          { title: 'M+2月预测数量', dataIndex: 'forecastQtyM2', width: 100, align: 'center' },
          { title: 'M+1月预测数量', dataIndex: 'forecastQtyM1', width: 100, align: 'center' },
          {
            title: '三个月内是否可消耗完',
            dataIndex: 'threeMonthConsumeIs',
            width: 100,
            align: 'center',
            customRender: (text, record) => ({ 0: '否', 1: '是' }[record.threeMonthConsumeIs])
          },
          { title: '预计消耗月数', dataIndex: 'expectConsumeMonth', width: 100, align: 'center' },
          { title: '计划数量(总数)', dataIndex: 'planQuantity', scopedSlots: { customRender: 'planQuantity' }, width: 100, align: 'center' },
          { title: '入库数量', dataIndex: 'storageQuantity', width: 100, align: 'center' },
          { title: '入库时间', dataIndex: 'storageTime', width: 140, scopedSlots: { customRender: 'time' }, align: 'center' },
          { title: '单据类型', dataIndex: 'demandType', scopedSlots: { customRender: 'demandType' }, width: 180, align: 'center' },
          { title: '签署供应商', dataIndex: 'factoryNameStr', width: 120, align: 'center' },
          { title: '签署数量', dataIndex: 'totalQuantityStr', width: 100, align: 'center' },
          { title: '签署日期', dataIndex: 'contractSignTimeStr', width: 140, ellipsis: true, align: 'center' },
          { title: '当月满足数量', dataIndex: 'curMonthSatisfyQty', width: 100, align: 'center' },
          { title: '当月满足率', dataIndex: 'curMonthSatisfyRate', width: 100, scopedSlots: { customRender: 'curMonthSatisfyRate' }, align: 'center' },
          { title: '次月累计满足数量', dataIndex: 'nextMonthAccumulatedSatisfyQty', width: 100, align: 'center' },
          { title: '次月满足率', dataIndex: 'nextMonthSatisfyRate', width: 100, scopedSlots: { customRender: 'nextMonthSatisfyRate' }, align: 'center' },
          { title: '上一版本M+2月发货数量', dataIndex: 'preVersionMonthShipmentQtyM2', width: 100, align: 'center' },
          { title: '上一版本M+1月发货数量', dataIndex: 'preVersionMonthShipmentQtyM1', width: 100, align: 'center' },
          { title: '上一版本M月发货数量', dataIndex: 'preVersionMonthShipmentQtyM', width: 100, align: 'center' },
          { title: '最新版本M+2月发货数量', dataIndex: 'latestVersionMonthShipmentQtyM2', width: 100, align: 'center' },
          { title: '最新版本M+1月发货数量', dataIndex: 'latestVersionMonthShipmentQtyM1', width: 100, align: 'center' },
          { title: '最新版本M月发货数量', dataIndex: 'latestVersionMonthShipmentQtyM', width: 100, align: 'center' },
          { title: 'M+2月已提零星预测', dataIndex: 'providedSporadicPredictQtyM2', width: 100, align: 'center' },
          { title: 'M+1月已提零星预测', dataIndex: 'providedSporadicPredictQtyM1', width: 100, align: 'center' },
          { title: 'M月已提零星预测', dataIndex: 'providedSporadicPredictQtyM', width: 100, align: 'center' },
          { title: '第一层(现有供应余量可覆盖)', dataIndex: 'firstLayer', width: 100, align: 'center' },
          { title: '第二层(加单基线内)', dataIndex: 'secondLayer', width: 100, align: 'center' },
          { title: '第三层(超出加单基线)', dataIndex: 'thirdLayer', width: 100, align: 'center' },
          { title: 'M月销量', dataIndex: 'salesQuantityM', width: 100, align: 'center' },
          { title: 'M-1月销量', dataIndex: 'salesQuantityM1', width: 100, align: 'center' },
          { title: 'M-2月销量', dataIndex: 'salesQuantityM2', width: 100, align: 'center' },
          { title: 'M月在途', dataIndex: 'inTransitVolumeM', width: 100, align: 'center' },
          { title: '库存现货实数', dataIndex: 'stockInventory', width: 100, align: 'center' },
          { title: '来源单号', dataIndex: 'sourceCode', width: 150, ellipsis: true, align: 'center' },
          { title: '状态', dataIndex: 'dmStatusDesc', width: 90, ellipsis: true, align: 'center' },
          { title: '创建人', dataIndex: 'createName', width: 100, ellipsis: true, align: 'center' },
          { title: '创建日期', dataIndex: 'createTime', scopedSlots: { customRender: 'time' }, width: 140, ellipsis: true, align: 'center' },
          { title: '提交人', dataIndex: 'submittedByName', width: 100, ellipsis: true, align: 'center' },
          { title: '提交时间', dataIndex: 'submissionTime', scopedSlots: { customRender: 'time' }, width: 140, ellipsis: true, align: 'center' },
          { title: '审核人', dataIndex: 'checkedByName', width: 100, align: 'center' },
          { title: '审核时间', dataIndex: 'checkTime', scopedSlots: { customRender: 'time' }, width: 140, ellipsis: true, align: 'center' },
          { title: '作废人', dataIndex: 'nullifier', width: 100, align: 'center' },
          { title: '作废时间', dataIndex: 'nullifierTime', scopedSlots: { customRender: 'time' }, width: 140, ellipsis: true, align: 'center' },
          { title: '项目组', dataIndex: 'projectTeam', width: 120, align: 'center' }
          // ,
          // {
          //   title: '操作',
          //   width: 100,
          //   dataIndex: 'operation',
          //   scopedSlots: { customRender: 'operation' },
          //   stickyFixed: 'right'
          // }
        ],
        uomClassOptions: [],
        unitOfMeasureList: []
      }
    },
    created () {
      this.getLookupList('SCP_DOC_TYPE', 'orderType')
      this.getLookupList('SCP_PROJECT_TEAM', 'projectTeams')
    },
    mounted () {
      this.onSearch()
    },
    methods: {
    handleDemandTypeChange (val, record) {
      apiScpDmSporadicState({ id: record.id, demandType: val }).then((response) => {
              if (response.code === 200) {
                this.$message.success('保存成功')
                // this.onSearch()
                this.$set(record, 'demandType', val);
              } else {
                this.$set(record, 'demandType', '');
                this.$message.error(response.msg)
              }
            })
    },
    demandTypeDisabled(row, val) {
      // 需求类型为摆场需求时，只能选择1220专货，其他置灰
      if(row.demandDeliveryType === '30' && val !== '1220') { return true }
      // 需求类型为非摆场需求时，不能选择1220专货（置灰）
      if(row.demandDeliveryType !== '30' && val === '1220') { return true }
      return false
    },
    getLookupList (type, arr) {
          const lookupQueryParams = {
            lookupType: type,
            current: 1,
            pageSize: 999
          }
          this.getLookupListData(lookupQueryParams).then().then(response => {
            this[arr] = response.rows
            if (type === 'SCP_DOC_TYPE') {
                const filteredArray = response.rows.filter(function (obj) {
                    return obj.attribute2 === "1";
                    });
                    this[arr] = filteredArray
            }
          })
    },
    handlePanelChange (value) {
      const yearMonth1 = value[0]
      const yearMonth2 = value[1]
      this.queryParams.demandDeliveryDateFrom = yearMonth1
      this.queryParams.demandDeliveryDateTo = yearMonth2
      this.demandDeliveryDate = value
    },
     handleOperation (text, record) {
            this.cfId = record.id
            this.demandDeliveryDate = record.demandDeliveryDate ? moment(record.demandDeliveryDate).format('YYYY/MM/DD') : ''
            this.planQuantity = record.quantityDemand ? record.quantityDemand : 0
            this.$refs.createModal.show(record.id, record.dmStatus, record)
        },
         /** 行选中 */
     selectedRowChange (selectedRowKeys, selectedRows) {
        this.selectedRowKeys = selectedRowKeys;
        this.selectedRows = selectedRows;
      },
      /**
       *
       * @param {*} type
       * 零星需求：
       * 提交：2
       * 审核通过：3
       * 驳回：1
       * 作废：4
       */
      distributeMsg (type) {
        if (this.selectedRows.length === 0) {
          this.$message.error('请选中操作项')
          return
        }
        let flag = false
        for (let i = 0; i < this.selectedRows.length; i++) {
          if (!this.selectedRows[i].demandType) {
           if (type !== 4 && type !== 1) {
            this.$message.warning('必填项单据类型不能为空！')
            flag = true
            return
           }
          }
        }

        if (flag) {
          return false
        }
        let typeTips = ''
        if (type === 1) {
          typeTips = '确定返回创建状态？'
        } else if (type === 2) {
          typeTips = '确定提交选中数据？'
        } else if (type === 3) {
          typeTips = '确定审核通过选中数据？'
        } else if (type === 4) {
          typeTips = '作废后不可恢复，请确认'
        }
        const self = this
        const newObjectArray = this.selectedRows.map(row => ({ id: row.id }));
        const params = {
          scpDmSporadicList: newObjectArray,
          status: type
        }
        this.$confirm({
          title: `提示`,
          content: typeTips,
          okText: '确定',
          okType: 'danger',
          cancelText: '取消',
          onOk () {
            apiScpDmSporadic(params).then((response) => {
              if (response.code === 200) {
                self.$message.success('提交成功')
                self.onSearch()
              } else {
                self.$message.error(response.msg)
              }
            })
          }
        })
      },
      uomClassOnChange () {
        this.getUnitOfMeasureList()
      },
      /** 导入excel窗体开启 */
      handleImport(value) {
        const { file } = value
        // 校验文件类型
        const verifyFileName = file.name.substring(file.name.lastIndexOf("."))
        const acceptList = this.uploadConfig.accept.split(',')
        if(acceptList.indexOf(verifyFileName.toLowerCase()) === -1) {
          this.$message.warning('上传格式不正确，仅支持：' + this.uploadConfig.accept)
          return false;
        }
        // const isLt = file.size / 1024 / 1024 < this.uploadConfig.limitSize;
        // 校验大小
        // if(!isLt) {
        //   this.$message.warning(`上传文件不超过${this.uploadConfig.limitSize}M`)
        //   return false;
        // }
        const formData = new FormData()
        formData.append("file", file)
        this.isUploading = true;
        apiImportSporadic(formData).then(res => {
          parseResFileOrJson(res, () => {
            this.onSearch(); // 重新查询
          }, '零星需求导入异常.xlsx');
        }).finally(() => {
          this.isUploading = false;
        })
      },
      // 导入导出excel
      /** 导出按钮操作 */
      handleExport () {
        const params = this.queryParams
        this.$refs.download.openModal(params)
        // this.download('scp/scpDmSporadic/export', {
        //   ...this.queryParams
        // }, `零星需求管理_${new Date().getTime()}.xlsx`)
      },

      // confirmHandleStatus (row) {
      //   const text = row.status === 'Y' ? '停用' : '启用'
      //   row.status = row.status === 'Y' ? 'N' : 'Y'
      //   updateUnit(row)
      //   .then(() => {
      //     this.$message.success(
      //       text + '成功',
      //       3
      //     )
      //     this.onSearch()
      //   }).catch(function () {
      //     row.status = row.status === 'Y' ? 'N' : 'Y'
      //     this.$message.error(
      //       text + '发生异常',
      //       3
      //     )
      //   })
      // },
      // cancelHandleStatus (row) {
      // },
      baseUomFlagFormat (row, column) {
        return this.selectDictLabel(this.baseUomFlagOptions, row.baseUomFlag)
      },
      // 表单搜索
      onSearch () {
        this.$refs.dataTable.searchParams = this.queryParams
        this.$refs.dataTable.getData()
        this.dmStatus = this.queryParams.dmStatus
      },
      /** 重置按钮操作 */
      resetQuery () {
        this.dmStatus = undefined;
        this.queryParams = {
          createBy: undefined,
          projectTeam: undefined,
          demandType: undefined,
          planCode: undefined,
          dmStatus: undefined,
          demandDeliveryDate: undefined,
          itemCode: undefined,
          sourceCode: undefined,
          applicantList: undefined,
          demandDeliveryDateFrom: undefined,
          demandDeliveryDateTo: undefined
          }
          this.demandDeliveryDate = undefined
        this.onSearch()
        this.$refs.createBySearchRef.handleSearch(''); // 重新查询创建人下拉
      },
      // 搜索框展开、收起
      toggleAdvanced () {
        this.advanced = !this.advanced
      }
    }
  }
  </script>

<style lang="less"  scoped>
  .ml10{
    margin-left: 10px;
  }.ellipsis{
      display:block;
      width:150px;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
    /deep/.ant-input{
      width: 100%;
    }
  .select-part{
    /deep/.ant-select{
      width: 100%;
    }
  }
  </style>
